import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { constants } from '../../utitlity/constant';
import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: "ntb-number",
    template: require('./number.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class NumberFieldComponent implements OnInit {
    @Input() question: QuestionBase<any>;
    @Input() questions: any = [];
    @Input() form: NgForm;
    // @Input() prefillData: any;
    fieldModel: any;
    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }
    ngOnInit() {
    }
    checkInput(question) {

        //let invalidChars = /(^\s+|\s+$)/g;
        let invalidChars = /[^0-9]/gi;
        if(question.backendField == "emiratesId") {
            if (invalidChars.test(question.value) || parseInt(question.value) == 0) {
                if (parseInt(question.value) == 0) {
                    question.value = "";
                }
                else {
                    question.value = question.value.replace(invalidChars, "");
                    if (parseInt(question.value) == 0) {
                        question.value = "";
                    }
                }
            }
        }
        else {
            if(invalidChars.test(question.value)) {
                question.value = question.value.replace(invalidChars, "");
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/number/number.component.ts